import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle, } from 'react-accessible-accordion';
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import $ from 'jquery'
import '../../../assets/css/accordion-arrow-fancy.css'
import { get } from "../../../server/actionsParent";
import { MONTH } from "../../../server/constants";
import PDF from 'react-pdf-js'
import { BeatLoader } from 'react-spinners';
import PropTypes from "prop-types";
import MenuComponent from '../../SchoolAdmin/Menu/menuComponent';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getOrderMenuOptions, getDistrictOrderMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions'
import ReactTable from 'react-table'

function menu_sort(a, b) {
    return new Date(b.monthDate) - new Date(a.monthDate)
}

class ViewOrdersDistrict extends Component {
    componentDidMount = () => {

    }
    componentWillMount = () => {
        let id = this.props.data;
        let schoolId = this.props.mealSchoolId;
        if (sessionStorage.getItem('ROLE') == 'ROLE_PARENT') {
            this.setState({
                isParent: true,
                studentId: id,
                mealSchoolId: schoolId,
                mealType: (getDistrictOrderMenuOptions(schoolId)[0] || '')
            }, () => {
                this.bindOrdersData(id);
            });
        } else {
            this.setState({
                isParent: false,
                studentId: id,
                mealSchoolId: schoolId,
                mealType: (getDistrictOrderMenuOptions(schoolId)[0] || '')
            }, () => {
                this.bindOrdersData(id);
            });
        }
    }
    bindOrdersData = (id) => {
        get('/mealOrderDetailses/search/findByStudentAndSchoolYear?studentRecId=' + id + '&mealType=' + this.state.mealType + '&access_token=').then((response) => {
            this.setState({ loading: true });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log("Orders of student returned", data)
            const filterData = data._embedded.mealOrderDetailses.filter(item => {
                return item.menuType === this.state.mealType;
            })
            filterData.forEach(order => {
                let month = order.yearMonth.slice(-2);
                let year = order.yearMonth.substring(0, 4)
                order.monthYear = MONTH[month - 1] + " " + year
                order.monthDate = new Date(year, month - 1, 1)
                order.studentRecId = id;
                order.pdfLink = order.menuOrderedPdfLink;

            });
            filterData.sort(menu_sort);
            this.setState({ orders: filterData, loading: false })
        })
            .catch(
                (error) => {
                    console.log('Get orderlist response', error)
                    this.setState({ loading: false });
                }
            )

    }

    constructor() {
        super();
        this.state = {
            orders: [],
            mealSchoolId: 0,
            studentId: 0,
            isParent: false,
            mealType: '',
            fireRedirect: false,
            pageNumber: 1,
            loading: false
        }

    }

    render() {
        const checkboxProps = {

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (

            <section className="full-width clearfix">
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <h2>
                            <div className="row">
                                <div className="col-md-3">
                                    <span>View Order's</span>
                                </div>
                                <div className="col-md-8 text-right">
                                    <MenuOptions menuOptionsList={getDistrictOrderMenuOptions(this.state.mealSchoolId)}
                                        onOptionSelect={(type) => {
                                            this.setState({ mealType: type }, () => {
                                                this.bindOrdersData(this.state.studentId);
                                            })
                                        }} selectedOption={(this.state.mealType)} />
                                </div>
                                {/*  <div className="col-md-1 text-right">
                                <button className=" btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                let _self=this;
                                _self.context.router.history.goBack() ;
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                            </div> */}
                            </div>
                        </h2>
                    </div>
                    <div className="row">
                    </div>
                    <div className="row">
                        <ReactTable
                            data={this.state.orders}
                            style={{ width: "98%" }}
                            columns={[
                                {
                                    Header: "MONTH",
                                    style: { textAlign: 'center' },
                                    accessor: "monthYear"

                                },
                                {
                                    Header: "ORDER PDF",
                                    accessor: "pdf",
                                    style: { textAlign: 'center' },
                                    Cell: ({ row }) => (<div>
                                        <a title="Click to Download PDF" href={row._original.menuOrderedPdfLink}
                                            target='_blank'
                                            className="fa fa-file-pdf-o fa-2x"><i /></a>
                                    </div>)
                                }
                            ]}
                            defaultPageSize={5}
                            className="-striped -highlight"
                            {...checkboxProps}
                            SubComponent={row => {
                                return (
                                    <div className="col-md-12">
                                        <MenuComponent
                                            row={row}
                                            schoolId={this.state.mealSchoolId}
                                            mealType={this.state.mealType}
                                            date={row.original.monthDate}
                                            type="student"

                                        />
                                    </div>
                                )
                            }}
                        />
                    </div>
                </div>
            </section>
        );
    }
}

ViewOrdersDistrict.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ViewOrdersDistrict;


// WEBPACK FOOTER //
// ./src/components/District/manageStudents/viewOrderDistrict.js